import { useI18n } from '@affine/i18n';
import type { FC } from 'react';

import { EnumSelect } from '../controls/enum-select';
import { PAGINATION_OPTIONS } from './option-constants';
import type { SectionProps } from './types';

export const PaginationSection: FC<SectionProps> = ({ row, setField }) => {
  const t = useI18n();
  return (
    <EnumSelect
      label={t['com.streamlain.customApps.viewConfig.pagination.label']()}
      data-sl-field="pagination"
      value={row.pagination}
      options={PAGINATION_OPTIONS}
      onChange={v => setField('pagination', v)}
    />
  );
};
